<template>
    <tasks-complete-invoke
        :params="{
            task: task.uuid
        }"
        v-slot="{
            error,
            invoke
        }"
    >
        <div class="w-6 h-6">
            <input-checkbox
                v-model="is_checked"
                :is-interactive="task.can_complete"
                @toggle="invoke"
                class="block"
            />

            <error-modal
                v-if="error && $error.is(error, { exclude: [422] })"
                :error="error"
            />
        </div>
    </tasks-complete-invoke>
</template>

<script>
    import TasksCompleteInvoke from './tasks-complete-invoke'

    export default {
        components: {
            TasksCompleteInvoke
        },
        props: {
            task: {
                type: Object,
                required: true
            }
        },
        data () {
            return {
                is_checked: this.task.is_complete
            }
        }
    }
</script>
